module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow_triangle_down_solid-12f800ce971652adb4a0e41581a975fe.svg";